import React, { Component } from "react";
import Paper from "@mui/material/Paper";
import {
  FormControlLabel,
  CardHeader,
  CardContent,
  FormControl,
  Radio,
  Card,
  RadioGroup,
  FormLabel,
} from "@mui/material";
import "./css/InverterSelectorForm.css";

export class EnclosureView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shakerTableHide: this.props.shakerTable,
      showNextButton:
        this.props.cabType === "" && this.props.shakerTable === ""
          ? false
          : true,
      cabFilteredData: {},
      shakerValReset: "",
      cabTypeData: this.props.cabType,
      shakerTableData: this.props.shakerTable,
      fieldSelectableVoltShow: this.props.fieldSelectableVoltdata !== "",
    };
    this.props.showNextButton(
      this.props.cabType === "" && this.props.shakerTable === "" ? false : true
    );
  }

  cabinetOption = (event) => {
    if (event.target.value === "Indoor") {
      //INDOOR
      this.props.cabinetFilteredData("Indoor");
      this.props.shakerTableFilteredData(false);

      if (this.props.totalcap > 1900) {
        this.setState({ shakerTableHide: true });
      } else {
        this.setState({ showNextButton: true });
        this.props.showNextButton(true);
      }

      // if (!this.state.shakerTableData) {
      //   this.props.shakerTableFilteredData(false);
      // }
    } else if (event.target.value === "Outdoor") {
      //Show the shaker table question
      this.setState({ shakerTableHide: false });
      this.props.showNextButton(true);
      //OUTDOOR
      this.props.cabinetFilteredData("Outdoor");
      this.props.shakerTableFilteredData(false);
    } else {
    }

    this.setState({ shakerValReset: " " });
  };

  shakerTableOption = (event) => {
    //console.log("value of shaker table result")
    //console.log(event.target.value)

    this.props.shakerTableFilteredData(event.target.value);

    this.setState({ showNextButton: true });
    this.setState({ fieldSelectableVoltShow: true });
    this.props.showNextButton(true);
  };

  fieldSelectableVoltOption = (event) => {
    this.props.fieldSelectableVoltOption(event.target.value);
  };

  render() {
    return (
      //App starts here

      <Card elevation={10}>
        <CardHeader
          titleTypographyProps={{
            fontFamily: "Ford-Normal",
          }}
          className="paperh-title"
          title="Enclosure Type"
        />
        <CardContent className="et-CardContent">
          <Paper elevation={5} className="et-PaperCabinet">
            <FormControl>
              <FormLabel
                sx={{ fontFamily: "Ford-Normal" }}
                id="demo-radio-buttons-group-label"
              >
                Select your Cabinet
              </FormLabel>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                name="radio-buttons-group"
                //defaultValue={this.state.cabTypeData}
                sx={{ "& .MuiTypography-root": { fontFamily: "Ford-Normal" } }}
              >
                <FormControlLabel
                  value="Indoor"
                  control={<Radio />}
                  label="Indoor"
                  onChange={this.cabinetOption}
                />
                {this.props.phaseType && this.props.totalcap > 1500 && (
                  <FormControlLabel
                    value="Outdoor"
                    control={<Radio />}
                    label="Outdoor"
                    onChange={this.cabinetOption}
                  />
                )}
              </RadioGroup>
            </FormControl>
          </Paper>
          {this.state.shakerTableHide && this.props.totalcap >= 1800 && (
            <Paper elevation={5} className="et-PaperCabinet">
              <FormControl>
                <FormLabel
                  sx={{ fontFamily: "Ford-Normal" }}
                  id="demo-radio-buttons-group-label"
                >
                  Shaker Table Tested?
                </FormLabel>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  //value={this.shakerValReset}
                  name="radio-buttons-group"
                  defaultValue={this.state.shakerTableData}
                  sx={{
                    "& .MuiTypography-root": { fontFamily: "Ford-Normal" },
                  }}
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="Yes"
                    onChange={this.shakerTableOption}
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="No"
                    onChange={this.shakerTableOption}
                  />
                </RadioGroup>
              </FormControl>
            </Paper>
          )}
          {this.props.totalcap >= 7000 &&
            this.props.totalcap <= 50000 &&
            this.props.phaseTypeData === 3 &&
            this.state.fieldSelectableVoltShow && (
              <Paper>
                <FormControl>
                  <FormLabel
                    sx={{ fontFamily: "Ford-Normal" }}
                    id="demo-radio-buttons-group-label"
                  >
                    Is your load balanced?
                  </FormLabel>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="radio-buttons-group"
                    defaultValue={this.props.fieldSelectableVoltdata}
                    sx={{
                      "& .MuiTypography-root": { fontFamily: "Ford-Normal" },
                    }}
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label="Yes"
                      onChange={this.fieldSelectableVoltOption}
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label="No"
                      onChange={this.fieldSelectableVoltOption}
                    />
                  </RadioGroup>
                </FormControl>
              </Paper>
            )}
        </CardContent>
      </Card>
    );
  }
}

export default EnclosureView;
